<template>
  <div class="smartSite-index">
    <!--    <img alt="banner" src="@/assets/images/smartSite/banner.png" style="width: 100%;" />-->

    <SecondaryBanner
      :height="bannerInfo.height"
      :icon="bannerInfo.iconImage"
      :iconText="bannerInfo.iconText"
      :title="bannerInfo.title"
      :bgImage="bannerInfo.bgImage"
      :videoUrl="bannerInfo.videoUrl"
    />
-
    <AnchorTabs :tabList="tabList" />

    <div
      id="overview"
      class="overview"
      v-scroll-animate="{ animation: 'fadeInUp', delay: 100 }"
    >
      <div class="title">什么是 <span>数字智慧工地平台</span>？</div>
      <div class="text">
        数字智慧工地平台是建筑行业数字化转型的核心驱动力，它深度融合云计算、大数据、物联网与人工智能等先进技术，将建筑工地的人员、设备、物料、安全、质量等各环节全方位数字化并智能互联。通过智能安全帽、设备传感器、物料追踪系统等，精准采集数据，实现人员的精细化管理、设备的智能化运维、物料的精准化调配，同时借助高清摄像头与智能图像识别保障工地安全可视化，依据标准把控质量管理标准化，最终将海量数据转化为直观报表与图表，为管理决策提供科学依据，提升工地整体效益，塑造建筑行业智能化、高效化、可持续发展的未来新貌。
      </div>
    </div>

    <div id="solutions" class="cardBox">
      <div
        class="title"
        v-scroll-animate="{ animation: 'fadeInUp', delay: 100 }"
      >
        技术功能有哪些？
      </div>

      <div v-for="(part, i) in dataList" class="part" :key="i">
        <div
          class="title"
          v-scroll-animate="{ animation: 'fadeInUp', delay: 100 }"
        >
          {{ part.title }}
        </div>

        <div
          class="content"
          v-scroll-animate="{ animation: 'fadeInUp', delay: 100 }"
        >
          {{ part.content }}
        </div>

        <div
          v-for="(item, index) in part.list"
          :key="index"
          class="card"
          v-scroll-animate="{ animation: 'fadeInUp', delay: 100 }"
        >
          <img
            alt="image"
            :src="item.picUrl"
            class="image"
            :style="{
              order: index % 2 ? 0 : 1,
            }"
          />

          <div
            :style="{
              order: index % 2 ? 1 : 0,
              margin: 'auto 0',
              height: 'fit-content',
            }"
          >
            <div class="subtitle">{{ item.title }}</div>

            <div class="text">{{ item.content }}</div>
          </div>
        </div>
      </div>
    </div>

    <div id="cooperate">
      <!-- :bgImage="
          require('@/assets/images/intelligentImg/bg-advertising-smartSite.png')
        " -->
      <ProductGet
        title="根据您的业务需要定制数字建设管理平台！"
        subTitle="狄诺尼智能建造，为您带来一站式设计解决方案"
        :showWhiteBg="true"
        :downLoadBtn="{
          label: '下载产品手册',
          fileUrl: '/download?anchor=manual',
          show: true,
        }"
        :contactBtn="{
          label: '让销售人员联系您',
        }"
      />
    </div>
  </div>
</template>

<script>
import AnchorTabs from "@/components/AnchorTabs.vue";

import picture1 from "@/assets/images/smartSite/picture1.png";
import picture2 from "@/assets/images/smartSite/picture2.png";
import picture3 from "@/assets/images/smartSite/picture3.png";
import picture4 from "@/assets/images/smartSite/picture4.png";
import picture5 from "@/assets/images/smartSite/picture5.png";
import picture6 from "@/assets/images/smartSite/picture6.png";
import picture7 from "@/assets/images/smartSite/picture7.png";
import picture8 from "@/assets/images/smartSite/picture8.png";
import picture9 from "@/assets/images/smartSite/picture9.png";
import picture10 from "@/assets/images//smartSite/picture10.png";
import picture11 from "@/assets/images//smartSite/picture11.png";
import picture12 from "@/assets/images//smartSite/picture12.png";
import picture13 from "@/assets/images//smartSite/picture13.png";
import picture14 from "@/assets/images//smartSite/picture14.png";
import picture15 from "@/assets/images//smartSite/picture15.png";
import picture16 from "@/assets/images//smartSite/picture16.png";
import picture17 from "@/assets/images//smartSite/picture17.png";
import picture18 from "@/assets/images//smartSite/picture18.png";
import picture19 from "@/assets/images//smartSite/picture19.png";
import picture20 from "@/assets/images//smartSite/picture20.png";
import picture21 from "@/assets/images//smartSite/picture21.png";
import picture22 from "@/assets/images//smartSite/picture22.png";
import picture23 from "@/assets/images//smartSite/picture23.png";
import ProductGet from "@/components/ProductGet.vue";
import SecondaryBanner from "@/components/SecondaryBanner.vue";
import { prefix } from "@/utils/env";

export default {
  name: "prefabrication",
  props: {},
  components: {
    SecondaryBanner,
    ProductGet,
    AnchorTabs,
  },
  data() {
    return {
      bannerInfo: {
        height: "845px",
        iconImage: require("@/assets/images/smartSite/logo.png"),
        bgImage: require("@/assets/images/intelligentImg/bg-secondary-banner-management.png"),
        iconText: "数字智慧工地平台",
        title: "以科技创新为引擎，实现工地管理智能化、可视化与高效化",
        // pictureUrl: require("@/assets/images/intelligentImg/bg-secondary-banner-smartSite-posterImg.png"),
        posterImg: require("@/assets/images/intelligentImg/bg-secondary-banner-smartSite-posterImg.png"),
        videoUrl: `${prefix}/static/video/smartSite.mp4`,
      },
      tabList: [
        {
          name: "全部",
          value: "overview",
        },
        {
          name: "功能",
          value: "solutions",
        },
        {
          name: "合作",
          value: "cooperate",
        },
      ],
      dataList: [
        {
          title: "人员管理",
          content:
            "人员管理系统集成了物联网、大数据、云计算等现代信息技术，提供精细化的人员管理解决方案。系统通过各类传感设备实时采集人员位置、活动轨迹及行为数据，并传输至智慧工地平台，实现对工地现场人员的实时监控、考勤、门禁控制及安全预警，显著提升施工现场的人员监管效率。",
          list: [
            {
              title: "电子围栏",
              content:
                "设定虚拟边界，实时监控人员进出，自动报警提醒，防止误入危险区域或擅自离岗，提升现场安全管理。",
              picUrl: picture1,
            },
            {
              title: " 人脸识别考勤",
              content:
                "高精度人脸识别，无接触快速考勤，云端存储与分析，提升考勤管理效率。",
              picUrl: picture2,
            },
            {
              title: "人员门禁系统",
              content:
                "智能门禁控制进出权限，实时记录人员通行数据，防止未经授权人员进入，提高现场安全性。",
              picUrl: picture3,
            },
            {
              title: "智能AI安全帽",
              content:
                "传感器实时监测人员定位、轨迹与行为，具备无线通信与预警功能，提高沟通效率，保障作业安全。",
              picUrl: picture4,
            },
          ],
        },
        {
          title: "现场安全管理",
          content:
            "现场安全智能管理依托高清视频监控、智能影像识别及环境监测等技术，通过全方位、多角度的监控手段，实时掌握施工现场的安全状况。结合AI视觉分析算法自动识别并预警现场危险源，提升施工过程中应急响应能力。环境监测系统实时采集并分析关键环境数据，确保施工现场符合安全环保标准。所有数据通过智慧工地平台实现互联互通，支持远程分析与决策，为工地安全管理提供科学依据。",
          list: [
            {
              title: "视频监控",
              content:
                "远程高清视频监控全面覆盖重点施工地段、关键施工部位、重点施工工序、事故易发区域等，保障施工安全。",
              picUrl: picture5,
            },
            {
              title: "智能影像识别",
              content:
                "AI视觉分析实时监测现场危险源，涵盖火情、烟雾及人员违规行为等，并提供风险预警。",
              picUrl: picture6,
            },
            {
              title: "环境监测",
              content:
                "监测施工环境空气、水质、噪声等环境指标，综合评价现场环境质量，确保达标。",
              picUrl: picture7,
            },
          ],
        },
        {
          title: "机械设备管理",
          content:
            "智能机械设备管理系统通过集成高精度传感器和智能控制算法，实时监控作业设备的运行状态。通过对设备监控数据进行智能分析，出现异常时，系统可自动触发预警并推送报警信息。针对桩机施工引导、智能摊铺与碾压等设备的管理，系统能够自动调整作业参数，确保施工精准度和安全性。通过数据自动采集与分析，系统为施工管理提供重要决策依据，有效提升设备运转效率，降低事故发生率。",
          list: [
            {
              title: "特种作业设备预警监控",
              content:
                "实时监测特种作业设备运转情况，出现异常时通过蜂鸣报警、语音预警和短信推送，及时提醒并保障施工作业安全。",
              picUrl: picture8,
            },
            {
              title: "桩机施工引导",
              content:
                "采用北斗高精度定位与多传感器融合技术，实现对桩机施工高精度引导，自动采集桩心坐标、深度等数据，结合可视化数据平台，远程指导管控打桩过程，实时预警并纠偏，提高管理效率。",
              picUrl: picture9,
            },
            {
              title: "挖掘机施工引导",
              content:
                "采用北斗高精度定位与多传感器融合技术，实时引导挖刀姿态，精准执行三维设计。支持无桩化施工、电子围栏防护、远程监管与自动纠偏，提升施工精度、安全性与管理效率。",
              picUrl: picture10,
            },
            {
              title: "智能摊铺",
              content:
                "通过高精度测量系统与智能控制算法，实现自动化摊铺，实时监控和调整摊铺质量，优化施工效率与材料利用率，减少人工操作，确保高精度施工质量。",
              picUrl: picture11,
            },
            {
              title: "智能碾压",
              content:
                "通过GPS定位和智能算法实现自动化碾压，优化作业路径，确保安全运行，提高施工精度与效率，实时监控工作数据。",
              picUrl: picture12,
            },
          ],
        },
        {
          title: "物料管理",
          content:
            "物料管理系统通过AIoT、大数据和云计算技术，实现施工现场物料管理的数字化和智能化。通过实时采集拌合站、运输车辆的生产数据、运输状态及温度监控等信息，实现精准调度和无缝对接。系统能够自动调整生产配比，优化运输路线，保证材料的质量与及时到场，提高材料利用率。通过集成的无人值守功能，降低人工成本，提升工作效率。",
          list: [
            {
              title: "拌合站生产数据采集管控",
              content:
                "通过AIoT、大数据和区块链技术，实现混凝土生产的数字化、智能化。包括智能下单、精准跟踪、自动配合比调整、车队调度和无人值守，提升效率与质量。",
              picUrl: picture13,
            },
            {
              title: "混合料运输监控",
              content:
                "通过车辆身份识别、GPS系统和温度监控，实现混合料运输全程实时监控。包括实时定位、电子围栏报警、自动数据采集和温度监控，确保运输精度和质量。",
              picUrl: picture14,
            },
            {
              title: "物料智能调度",
              content:
                "依托物联网技术，实时监控物料库存与流转情况，自动记录并预警低库存状况。结合智能算法，精准匹配物料需求与调度，提高物料使用率，并通过可视化报表分析助力精细化管理。",
              picUrl: picture15,
            },
          ],
        },
        {
          title: "工程车辆管理",
          content:
            "智能车辆管理系统采用车牌识别技术与物联网技术，结合GPS实时定位与远程监控，优化工地车辆的进出管理。系统能够智能记录车辆进出、行驶路线及称重数据，提升车辆运行精度和运输过程的安全性。通过实时采集与分析车辆数据，系统能够帮助管理人员精准调度车辆资源，确保施工进度与现场安全。",
          list: [
            {
              title: "车辆入场系统",
              content:
                "采用车牌识别与智能控制技术，实现工地车辆的高效进出管理，提升安全性和通行效率。",
              picUrl: picture16,
            },
            {
              title: "智能地磅系统",
              content:
                "基于物联网技术，实现无人值守自动称重，集成车牌识别、云端数据分析与视频监控，提高运销存管理效率，降低人工成本。",
              picUrl: picture17,
            },
            {
              title: "车辆定位调度",
              content:
                "基于GPS定位与物联网技术，实时监控车辆位置、行驶轨迹及运行状态，支持轨迹回放，提升调度可视化管理。结合电子联单系统，自动记录趟次数据，优化车辆调度与任务分配，并支持远程信息下发，确保运输效率与管理精准度。",
              picUrl: picture18,
            },
          ],
        },
        {
          title: "激光点云土石方算量",
          content:
            "依托激光点云技术，实现土石方测量智能化、自动化与可视化。通过扫描施工现场，精准计算填挖方量，并智能过滤非目标物体，确保数据计算准确。管理者可通过三维模型、动态报表和实时监控，掌握工程量变化，提高审核透明度。系统支持历史数据对比和趋势分析，为工程进度评估和成本控制提供科学依据，使测量更高效、管理更可控。",
          list: [
            {
              title: "高精度点云测量",
              content:
                "采用激光雷达技术，快速扫描施工现场，精细化建模，适用于大规模、复杂地形的土石方测量。",
              picUrl: picture19,
            },
            {
              title: "智能计算与自动分析",
              content:
                "专有软件精准计算土石方填挖量，智能过滤非目标物体，自动生成报表，提高计量审核效率，优化施工规划与成本控制。",
              picUrl: picture20,
            },
          ],
        },
        {
          title: "无人机管理应用",
          content:
            "利用无人机技术，通过高精度巡检、智能进度巡查与高效应急响应，实现施工现场的全面数字化监控。无人机搭载高清摄像头、高精定位及图像识别系统，能够快速采集现场数据，并上传至智慧工地平台，提升管理效率，优化施工安全与资源调度。",
          list: [
            {
              title: "高效巡检与安全监管",
              content:
                "无人机自动巡航覆盖施工现场全域，实时采集高清视频及定位数据，识别安全隐患、违规操作及设备异常，提高施工安全监管精度。",
              picUrl: picture21,
            },
            {
              title: "智能进度巡查",
              content:
                "通过无人机航拍比对历史数据，直观展现施工进度变化，辅助进度管理与资源调度优化。",
              picUrl: picture22,
            },
            {
              title: "快速应急响应",
              content:
                "结合应急预案，一键派遣无人机至问题区域，实时回传现场影像，为突发事件决策提供直观信息，提高应急处置效率。",
              picUrl: picture23,
            },
          ],
        },
      ],
    };
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.smartSite-index {
  width: 100%;
  height: 100%;
  background: #fff;
  .overview {
    width: 100%;
    height: 272px;
    padding: 40px calc(50% - 524px);
    display: flex;
    flex-direction: column;
    gap: 24px;

    .title {
      font-size: 24px;
      color: #000000;
      line-height: 24px;
      > span {
        font-weight: 600;
      }
    }
    .text {
      font-weight: 400;
      font-size: 14px;
      color: #000000;
      line-height: 32px;
      text-align: justify;
      font-style: normal;
      text-indent: 2em;
    }
  }

  .cardBox {
    width: 100%;
    padding: 40px calc(50% - 524px);
    display: flex;
    flex-direction: column;
    gap: 40px;

    .title {
      font-weight: 600;
      font-size: 24px;
      color: #000000;
      line-height: 24px;
      text-align: left;
    }

    .part {
      margin-top: 24px;
      display: flex;
      flex-direction: column;
      gap: 24px;
      border-bottom: 1px solid rgba(219, 219, 219, 0.5);
      padding-bottom: 24px;

      .title {
        font-weight: 600;
        font-size: 20px;
        color: #333333;
        line-height: 32px;
        text-align: left;
      }

      .content {
        font-weight: 400;
        font-size: 14px;
        color: #000000;
        line-height: 32px;
        text-align: justify;
        text-indent: 2em;
      }

      .card {
        opacity: 0;
        display: flex;
        gap: 78px;

        .image {
          width: 400px;
          height: 240px;
        }

        .subtitle {
          background-image: url("../../../../assets/images/smartSite/subtitle.png");
          width: 372px;
          background-repeat: no-repeat;
          text-align: center;
          height: 32px;
          font-weight: 400;
          font-size: 20px;
          color: #ffffff;
          line-height: 32px;
        }
        .text {
          width: 606px;
          font-weight: 400;
          font-size: 16px;
          color: #666666;
          line-height: 24px;
          text-align: justify;
          margin-top: 24px;
        }
      }
    }
  }
}
</style>
